import './Features.css';
import commissionImg from '../assets/features-commission.png';
import packagesImg from '../assets/features-packages.png';
import rolesImg from '../assets/features-roles.png';
import { useScrollReveal } from '../hooks/useScrollReveal';

function Features() {
    const [ref, visible] = useScrollReveal(0.1);
    const features = [
        {
            image: commissionImg,
            icon: 'fas fa-chart-line',
            title: 'Commission Reports',
            subtitle: 'Payroll, simplified.',
            description: 'Auto-calculate commissions and generate monthly reports ready for payroll.',
        },
        {
            image: packagesImg,
            icon: 'fas fa-box-open',
            title: 'Packages & Vouchers',
            subtitle: 'Sell more, track effortlessly.',
            description: 'Bundle treatments into packages and issue vouchers your patients can redeem anytime.',
        },
        {
            image: rolesImg,
            icon: 'fas fa-shield-alt',
            title: 'Role Management',
            subtitle: 'The right access for the right people.',
            description: 'Assign granular permissions to doctors, nurses, front desk, or any custom role you define.',
        },
    ];

    return (
        <section ref={ref} className={`features ${visible ? 'visible' : ''}`}>
            <div className="features-content">
                <h2>Built for how clinics actually work</h2>
                <p className="features-subtitle">
                    Powerful features designed around the workflows your team uses every day
                </p>

                <div className="features-list">
                    {features.map((feature, index) => (
                        <div key={index} className={`feature-block ${index % 2 !== 0 ? 'reverse' : ''}`}>
                            <div className="feature-image">
                                {feature.image ? (
                                    <img src={feature.image} alt={feature.title} />
                                ) : (
                                    <div className="feature-image-placeholder">
                                        <i className="fas fa-image"></i>
                                        <span>Illustration</span>
                                    </div>
                                )}
                            </div>
                            <div className="feature-text">
                                <span className="feature-label"><i className={feature.icon}></i> {feature.title}</span>
                                <h3><span className="feature-title-highlight">{feature.subtitle}</span> {feature.description}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Features;
